import { useQuery } from '@tanstack/react-query'
import type { IContentType } from '~/@api/generated-api-types-user/Api'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useHtmlContent(typeId: IContentType) {
  const client = useApiClientUser()
  return useQuery({
    queryKey: ['html-content', typeId],
    queryFn: () =>
      client.user
        .contentControllerGetContentById(typeId, {
          secure: true,
        })
        .then((response) => response.data.data),
  })
}

export { useHtmlContent }
